import React from 'react';
import {
    FormattedMessage
} from 'react-intl';
import Button from '../button/button.jsx';
import './login.css';
import PropTypes from 'prop-types';
import {defineMessages} from 'react-intl';
import {getMobileOS} from '../lib/supported-browser';
const messages = defineMessages({
    getCode: {
        id: 'gui.account.getCode',
        defaultMessage: 'send code',
        description: 'Get verification code button'
    },
    gettingCode: {
        id: 'gui.account.gettingCode',
        defaultMessage: 'Verifying...',
        description: 'Text while human verification is running'
    },
    time: {
        id: 'gui.account.time',
        defaultMessage: '{time} seconds',
        description: 'Time after retry'
    }
});

/** Component: countdown click button class */
class VerifyCode extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            time: 60,
            enable: false,
            // text: '获取验证码'
            isRequesting: false,
            text: 
            <FormattedMessage
                id='gui.account.getCode'
                defaultMessage='send code'
                description='Get verification code button'
            />,
            
        };
        this.timer = null;
        this.handleClick = this.handleClick.bind(this);
    }

    componentWillUnmount () {
        clearInterval(this.timer);
    }

    async handleClick () {
        const { time, enable, isRequesting } = this.state;
        const {onClick, disabled} = this.props;
        // 避免重复执行 Turnstile，处理中或计时中直接返回
        if (enable || disabled || isRequesting) return;
        this.setState((prevState, props) => ({
            isRequesting: true,
            text: <FormattedMessage
                id='gui.account.gettingCode'
                defaultMessage='Verifying...'
                description='Text while human verification is running'
            />
        }));
        const canNext = await onClick();
        // 终止条件
        if (!canNext) {
            this.setState((prevState, props) => ({
                isRequesting: false,
                text: <FormattedMessage
                    id='gui.account.getCode'
                    defaultMessage='send code'
                    description='Get verification code button'
                />
            }));
            return;
        }
        const updateSeconds = () => {
            if (this.state.time > 0) {
                this.setState((prevState, props) => ({
                    time: this.state.time - 1,
                    enable: true,
                    text: `${this.state.time}s`
                }));
            } else {
                this.setState((prevState, props) => ({
                    time: 60,
                    enable: false,
                    // text: '获取验证码'
                    text: <FormattedMessage
                        id='gui.account.getCode'
                        defaultMessage='send code'
                        description='Get verification code button'
                    />
                }));
                clearInterval(this.timer);
            }
        };
        this.setState((prevState, props) => ({
            isRequesting: false
        }));
        updateSeconds();
        this.timer = setInterval(() => {
            updateSeconds();
        }, 1000);
        // }
    }

    render () {
        const { time, enable, isRequesting } = this.state;
        const {disabled} = this.props;
        const buttonDisabled = enable || disabled || isRequesting;
        return (
            <div>
                { getMobileOS() === 'PC' ? 
                    <Button
                        className={buttonDisabled ? "codeButtonDisabledpc" : "codeButtonpc"}
                        disabled={buttonDisabled}
                        onClick={this.handleClick}
                    >
                        {this.state.text}
                    </Button> : <Button
                        className={buttonDisabled ? "codeButtonDisabled" : "codeButton"}
                        disabled={buttonDisabled}
                        onClick={this.handleClick}
                    >
                        {this.state.text}
                    </Button>
                }
            </div>
        );
    }
}

VerifyCode.propTypes = {
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    text: PropTypes.string,
    // intl: IntlShape
};
//
// VerifyCode.defaultProps = {
//     onClick: null
// };

// export default injectIntl(VerifyCode);
export default VerifyCode;
